import axios from 'axios';

const getAuthHeader = () => {
  const tokenStr = localStorage.getItem('user');
  if (tokenStr) {
    const token = JSON.parse(tokenStr).token;
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

const API_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/device-registrations`;

const getDeviceRegistrations = async (status) => {
  const params = status ? { status } : {};
  const response = await axios.get(API_URL, {
    headers: getAuthHeader(),
    params
  });
  return response.data;
};

const createDeviceRegistration = async (data) => {
  const response = await axios.post(API_URL, data, {
    headers: { ...getAuthHeader(), 'Content-Type': 'application/json' }
  });
  return response.data;
};

const updateDeviceRegistration = async (id, data) => {
  const response = await axios.put(`${API_URL}/${id}`, data, {
    headers: { ...getAuthHeader(), 'Content-Type': 'application/json' }
  });
  return response.data;
};

const deleteDeviceRegistration = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`, {
    headers: getAuthHeader(),
  });
  return response.data;
};

const importDeviceRegistrations = async (devices) => {
  const response = await axios.post(`${API_URL}/import`, { devices }, {
    headers: { ...getAuthHeader(), 'Content-Type': 'application/json' }
  });
  return response.data;
};

const getDepAccountInfo = async () => {
  const response = await axios.get(`${API_URL}/dep-account`, {
    headers: getAuthHeader(),
  });
  return response.data;
};

const getDepDeviceDetails = async (serialNumbers) => {
  const response = await axios.post(
    `${API_URL}/dep-devices`,
    { devices: serialNumbers },
    { headers: { ...getAuthHeader(), 'Content-Type': 'application/json' } }
  );
  return response.data;
};

const getDepProfile = async (profileUuid) => {
  const response = await axios.get(`${API_URL}/dep-profile`, {
    headers: getAuthHeader(),
    params: { profile_uuid: profileUuid },
  });
  return response.data;
};

const DEP_PROFILES_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/dep-profiles`;

const getDepProfiles = async () => {
  const response = await axios.get(DEP_PROFILES_URL, { headers: getAuthHeader() });
  return response.data;
};

const createDepProfile = async (profileUuid, profileName) => {
  const response = await axios.post(
    DEP_PROFILES_URL,
    { profile_uuid: profileUuid, profile_name: profileName },
    { headers: { ...getAuthHeader(), 'Content-Type': 'application/json' } }
  );
  return response.data;
};

const assignDepProfileToDevices = async (profileUuid, serialNumbers) => {
  const response = await axios.post(
    `${API_URL}/assign-dep-profile`,
    { profile_uuid: profileUuid, devices: serialNumbers },
    { headers: { ...getAuthHeader(), 'Content-Type': 'application/json' } }
  );
  return response.data;
};

const syncDepDevices = async () => {
  const response = await axios.post(
    `${API_URL}/sync-dep`,
    {},
    { headers: getAuthHeader() }
  );
  return response.data;
};

const deviceRegistrationService = {
  getDeviceRegistrations,
  createDeviceRegistration,
  updateDeviceRegistration,
  deleteDeviceRegistration,
  importDeviceRegistrations,
  getDepAccountInfo,
  getDepDeviceDetails,
  getDepProfile,
  getDepProfiles,
  createDepProfile,
  assignDepProfileToDevices,
  syncDepDevices,
};
export default deviceRegistrationService;
